export const DiscAlimentsData = {
  Cervical: [
    "Bulging disc",
    "Cervical radiculopathy",
    "Degenerated disc",
    "Neck Pain",
  ],
  Lumbar: [
    "Bulging disc",
    "Degenerated disc",
    "Facet Syndrome",
    "Herniated disc",
  ],
  Thoracic: [
    "Bulging disc",
    "Degenerated disc",
    "Facet Syndrome",
    "Herniated disc",
  ],
};

export const FacetSyndromeData = {
  Cervical: ["Facet Syndrome"],
  Lumbar: ["Facet Syndrome"],
  Thoracic: ["Facet Syndrome"],
};

export const ForwardHeadPostureData = {
  Cervical: ["Forward Head Posture"],
};

export const LigamentInjuryData = {
  Cervical: ["Subluxation"],
  Lumbar: ["Subluxation"],
  Thoracic: ["Subluxation"],
};

export const PostureData = {
  Cervical: ["Kyphosis", "Lordosis"],
  Lumbar: ["Kyphosis", "Lordosis"],
  Thoracic: ["Kyphosis", "Lordosis"],
};

export const SciaticaData = {
  Lumbar: ["Sciatica"],
};

export const ScoliosisData = {
  Thoracic: ["Scoliosis"],
};

export const SIJointData = {
  Lumbar: ["SI Joint Inflammation"],
};

export const SpinalDegenerationData = {
  Cervical: ["Degenerated Disc"],
  Lumbar: ["Degenerated Disc"],
  Thoracic: ["Degenerated Disc"],
};

export const SpondylolisthesisData = {
  Cervical: ["Spondylolisthesis"],
  Lumbar: ["Spondylolisthesis"],
  Thoracic: ["Spondylolisthesis"],
};

export const StenosisData = {
  Cervical: ["Stenosis"],
  Lumbar: ["Stenosis"],
  Thoracic: ["Stenosis"],
};

export const SubluxationData = {
  Cervical: ["Subluxation"],
  Lumbar: ["Subluxation"],
  Thoracic: ["Subluxation"],
};

export const TextNeckAndDeskData = {
  Cervical: ["Neck Pain"],
};

export const WhiplashData = {
  Cervical: [
    "Bulging disc",
    "Cervical radiculopathy",
    "Degenerated disc",
    "Neck Pain",
  ],
};

export const ROMData = {
  Cervical: [
    "Bulging disc",
    "Cervical radiculopathy",
    "Degenerated disc",
    "Neck Pain",
  ],
};

export const RotatorCuffInjuryData = {
  Shoulder: ["Rotator Cuff Injury"],
};

export const AdhesiveCapsulitisData = {
  Shoulder: ["Adhesive Capsulitis"],
};

export const ImpingmentData = {
  Shoulder: ["Impingement"],
};

export const MeniscusTearData = {
  Knee: ["Meniscus Tear"],
};

export const KneeDegenerationData = {
  Knee: ["Osteoarthritis"],
};

export const ACLInjuryData = {
  Knee: ["ACL Injury"],
};

export const MCLInjuryData = {
  Knee: ["MCL Injury"],
};

// export const OsteoarthritisData =
//   {
//     Knee: ["Osteoarthritis"],
//   };

export const AnkleData = {
  Ankle: ["Ankle Sprain"],
};

export const PlantarFasciitisData = {
  Foot: ["Plantar Fasciitis"],
};

export const PronationData = {
  Foot: ["Pronation"],
};

export const SupinationData = {
  Foot: ["Supination"],
};

export const EpicondylitisData = {
  Elbow: ["Epicondylitis"],
};

export const PiriformisSyndromeData = {
  Hip: ["Piriformis Syndrome"],
};

export const CarpalTunnelData = {
  Wrist: ["Carpal Tunnel"],
};
